import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  schoolRequest: [],
  schoolRequestSuccess: ["payload", "isLoading"],
  schoolRequestFail: ["error", "isLoading"],

  schoolRegisterRequest: ["payload"],
  schoolRegisterSuccess: ["payload", "isLoading"],
  schoolRegisterFail: ["error", "isLoading"],

  schoolClearMessage: []
});

const INITIAL_STATE = {
  isLoading: false,
  schools: [],
  message: ""
};

const schoolRequest = (state) => ({
  ...state,
  isLoading: true
});
const schoolRequestSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoading: false
});
const schoolRequestFail = (state, error) => ({
  isLoading: false,
  error
});

const schoolRegisterRequest = (state) => ({
  ...state,
  isLoading: true
});
const schoolRegisterSuccess = (state, payload) => ({
  ...state,
  ...payload,
  isLoading: false
});
const schoolRegisterFail = (state, error) => ({
  ...state,
  isLoading: false,
  error
});
const schoolClearMessage = (state) => ({
  ...state,
  message: ""
});

export default createReducer(INITIAL_STATE, {
  [Types.SCHOOL_REQUEST]: schoolRequest,
  [Types.SCHOOL_REQUEST_SUCCESS]: schoolRequestSuccess,
  [Types.SCHOOL_REQUEST_FAIL]: schoolRequestFail,

  [Types.SCHOOL_REGISTER_REQUEST]: schoolRegisterRequest,
  [Types.SCHOOL_REGISTER_SUCCESS]: schoolRegisterSuccess,
  [Types.SCHOOL_REGISTER_FAIL]: schoolRegisterFail,

  [Types.SCHOOL_CLEAR_MESSAGE]: schoolClearMessage
});
